// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__koPyr","icon":"SortAdornment_icon__ML3Uf","up":"SortAdornment_up__2gVCC","down":"SortAdornment_down__2TlDB","active":"SortAdornment_active__byABh"};